module.exports = __webpack_public_path__ + "static/fish-1-48e1a3e703d29449be52c6334eb2b9ee.jpg";